import { PointConversionActivationTransactionDepositModel, PointConvertionActivationRequestModel, PointDepositTransactionPostModel, PointWithdrawRequestModel } from '../models';
import { axiosSecure, handleError, handleResponse, RequestResponse } from './config';

// Get point transaction status by ID
export const getPointTransactionStatus = async (pointId: string): Promise<RequestResponse> => {
   return await axiosSecure
      .get(`/points/transaction/${pointId}`)
      .then((response) => handleResponse(response))
      .catch(handleError);
};

// Get pending swaps (withdraw and deposit)
export const getPendingSwaps = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/points/pending-transactions')
      .then((response) => handleResponse(response))
      .catch(handleError);
};

// Get conversion activation status
export const getConversionActivationStatus = async (wallet: string): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/points/conversion-activation/status', {
         params: {
            wallet,
         },
      })
      .then((response) => handleResponse(response))
      .catch(handleError);
};

// Activate conversion with points - send signed message
export const postConversionActivationWithPoints = async (request: PointConvertionActivationRequestModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post(`/points/conversion-activation/with-points?wallet=${request.signer}`, request)
      .then((response) => handleResponse(response))
      .catch(handleError);
};

// Activate conversion with SOL - get transaction to sign
export const getConversionActivationTransaction = async (wallet: string): Promise<RequestResponse> => {
   return await axiosSecure
      .get(`/points/conversion-activation/transaction?wallet=${wallet}`)
      .then((response) => handleResponse(response))
      .catch(handleError);
};

// Activate conversion with SOL - send signed transaction
export const postConversionActivationTransaction = async (request: PointConversionActivationTransactionDepositModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post(`/points/conversion-activation/transaction?wallet=${request.signer}`, request)
      .then((response) => handleResponse(response))
      .catch(handleError);
};

//       this.router.post('/request-withdraw', [checkAuth], PointController.requestWithdraw);
export const postPointWithdrawRequest = async (request: PointWithdrawRequestModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/points/withdraw/request', request)
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const getPointDepositTransaction = async (wallet: string, amount: number): Promise<RequestResponse> => {
   return await axiosSecure
      .get(`/points/deposit/transaction?wallet=${wallet}&amount=${amount}`)
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const postPointDepositTransaction = async (request: PointDepositTransactionPostModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/points/deposit/transaction', request)
      .then((response) => handleResponse(response))
      .catch(handleError);
};
